export default __webpack_public_path__ + "static/media/welcome.6a81871f.png";